export const generatePastelColor = (text) => {
    if (!text) return 'hsl(0, 0%, 90%)';
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }
    const h = hash % 360;
    const s = 70 + (hash % 10);
    const l = 85 + (hash % 10);
    return `hsl(${h}, ${s}%, ${l}%)`;
  };

  export const generateSaturatedColor = (text) => {
    if (!text) return 'hsl(0, 0%, 20%)';
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }
    const h = hash % 360; // Hue value between 0 and 360
    const s = 95 + (hash % 10); // Saturation closer to 100%
    const l = 30 + (hash % 10); // Lightness reduced to avoid pastels, between 40% and 60%
    return `hsl(${h}, ${s}%, ${l}%)`;
  };